import { DynamicConfig } from '@statsig/js-client';
import { StatsigService } from '@services/statsig.service';
import { Injectable } from '@angular/core';

export const CUSTOM_REPORTING_CONFIG_NAME = 'ent-custom-reporting-enabled';

export enum CUSTOM_REPORT_FEATURE {
  ANALYTIC_TAB = 'motive-analytic',
  AI_ANALYTICS = 'motive-ai',
  ANALYTICS_HUB = 'analytics-hub',
  MAX_PINNED_DASHBOARDS = 'max-pinned-dashboards',
  MULTI_SOURCE_ENABLED = 'multiple-data-sources-enabled',
}

export enum ThoughtSpotColumn {
  logId = 'log_id',
  startTerminal = 'start_terminal',
  endTerminal = 'end_terminal',
  tractorId = 'tractor_id',
  contractId = 'contract_id',
  serviceProvider = 'service_provider',
}

export type ThoughtSpotColumnGuidType = {
  [key in ThoughtSpotColumn]?: string;
};

@Injectable({ providedIn: 'root' })
export class EntCustomReportingDynamicConfigService {
  private config: DynamicConfig;

  constructor(
    private statsigService: StatsigService,
  ) {
    this.config = this.statsigService.evaluateDynamicConfig(CUSTOM_REPORTING_CONFIG_NAME);
  }

  public isMotiveAnalyticsTabEnabled(): boolean {
    return this.config.get(CUSTOM_REPORT_FEATURE.ANALYTIC_TAB, false);
  }

  public isAiAnalyticsFeatureEnabled(): boolean {
    return !!(this.config.value[CUSTOM_REPORT_FEATURE.AI_ANALYTICS] || false);
  }

  public isAnalyticsHubEnabled(): boolean {
    return !this.config.get(CUSTOM_REPORT_FEATURE.ANALYTIC_TAB, false) &&
      this.config.get(CUSTOM_REPORT_FEATURE.ANALYTICS_HUB, false)
    ;
  }

  public getMaxPinnedDashboards(): number {
    return this.config.get(CUSTOM_REPORT_FEATURE.MAX_PINNED_DASHBOARDS, 20);
  }

  public isMultiSourceEnabled(): boolean {
    return this.config.get(CUSTOM_REPORT_FEATURE.MULTI_SOURCE_ENABLED, false);
  }

  public getThoughtSpotColumnGuid(): ThoughtSpotColumnGuidType {
    return this.config.get('columnGuid', {});
  }
}
